"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import Script from "next/script"
import * as gtag from "@/lib/gtag"

export function GoogleAnalytics() {
  const pathname = usePathname()

  useEffect(() => {
    if (gtag.GA_TRACKING_ID && pathname) {
      gtag.pageview(pathname)
    }
  }, [pathname])

  // Don't render anything if GA_TRACKING_ID is not set
  if (!gtag.GA_TRACKING_ID) {
    return null
  }

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`} strategy="afterInteractive" />
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gtag.GA_TRACKING_ID}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  )
}
